import { esc } from "../ui/format.js";
import { uiGet } from "../ui/kit.js";
import { getCurrentTab } from "../app/shell.js";

/**
 * 🧭 Your next 3 moves (backend/advisor.py) on Overview, under the CEO Office card.
 * Reads the whole company and points at the three moves that matter most now;
 * each button opens the tab that does it. Read-only: it never acts for you. The same three moves open the Consulting
 * Report (2026-10-24: one advice system), and Overview links to the full report.
 */

function advHtml(a, { report = true } = {}) {
  return `<div class="adv-head"><h3>🧭 Your next 3 moves</h3><p>What matters most this month, from everything going on in the company.${report
    ? ` <button type="button" class="adv-link" data-adv-go="consulting">📋 The full Consulting Report →</button>` : ""}</p></div>
    <div class="adv-grid">${a.moves.map((m, i) => `<article class="adv-move">
      <span class="adv-n">${i + 1}</span><span class="adv-icon" aria-hidden="true">${m.icon}</span>
      <div class="adv-main"><b>${esc(m.title)}</b><span>${esc(m.why)}</span></div>
      <button type="button" class="${i === 0 ? "primary" : ""}" data-adv-go="${esc(m.tab)}">${esc(m.button)} →</button></article>`).join("")}</div>`;
}

const _advOriginalOverview = window.renderOverview;
window.renderOverview = async function (main, snap) {
  await _advOriginalOverview(main, snap);
  if (getCurrentTab() !== "overview") return;
  let a;
  try { a = await uiGet("/advisor"); } catch (e) { return; }
  if (getCurrentTab() !== "overview" || !a || !a.moves || !a.moves.length) return;
  const wrap = document.createElement("section");
  wrap.className = "adv";
  wrap.innerHTML = advHtml(a);
  // first thing under the page title: the moves are what you came for
  const after = main.querySelector(".panel-title");
  if (after) after.insertAdjacentElement("afterend", wrap); else main.prepend(wrap);
  wrap.querySelectorAll("[data-adv-go]").forEach((b) => b.addEventListener("click", () => window.ges && window.ges.showTab(b.dataset.advGo)));
};

window.gesAdvHtml = advHtml;

export { advHtml };
